import React from 'react';
import { Helmet } from 'react-helmet';

import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';

import ExtensionPolicyArea from './ExtensionPolicyArea';

const ExtensionPolicy = () => {
    return (
        <>
            <Helmet>
                <title>Extension Policies | Provider Extension | Chrome Extension</title>
                <link rel="canonical" href="https://yoursite.com/extension-policies" />
                <meta name="description" content="The policies for provider-extension Chrome extension" />
                <meta name="keywords" content="Chrome Extension, Provider Extension, Privacy Policy, Terms of Service, Data Usage, Chrome Web Store" />
            </Helmet>

            <CommonPageHeader title="Extension Policies" subtitle="Chrome Extension Policies" />
            <ExtensionPolicyArea />
        </>
    );
};

export default ExtensionPolicy;